<template>
  <img
    class="absolute top-0 h-full w-full"
    src="/images/wrapped/bgpage01.jpg"
    alt=""
  />
  <img
    class="absolute -top-[2px] w-full"
    src="/images/wrapped/gradient.png"
    alt=""
  />
  <img
    class="absolute left-4 top-8 h-auto max-h-[21px] w-auto max-w-[21px]"
    src="/images/wrapped/ddccircularlogo.png"
    alt=""
  />
  <div
    class="absolute top-6 flex h-fit w-full flex-col items-center justify-center"
  >
    <img
      class="mx-auto h-auto max-h-[40px] max-w-[50px]"
      src="/images/wrapped/flyingpigcloud.png"
      alt=""
    />
  </div>

  <div
    class="absolute top-[20%] flex h-[10%] w-full flex-col items-center justify-center"
  >
    <img
      class="h-full max-h-[62px] max-w-[62px]"
      src="/images/wrapped/festive.png"
      alt=""
    />
  </div>

  <img
    class="absolute -bottom-1 w-full"
    src="/images/wrapped/footerillustration.png"
    alt=""
  />
  <div class="absolute top-[30%] flex w-full flex-col items-center">
    <WrappedTextContainer
      class="whitespace-nowrap text-[86px] leading-none text-[#F690FF]"
    >
      in 2024
    </WrappedTextContainer>

    <div class="-mt-2">
      <WrappedTextContainer
        class="whitespace-nowrap text-[36px] leading-none text-[#D7EB61]"
      >
        you made pigs fly
      </WrappedTextContainer>
    </div>

    <div class="mt-2">
      <WrappedShadowContainer
        class="flex h-11 items-center bg-gradient-to-b from-white to-[#D7EB61] px-3"
      >
        <WrappedTextContainer
          class="whitespace-nowrap align-middle text-[23px] text-[#F690FF]"
        >
          #ddcwrapped
        </WrappedTextContainer>
      </WrappedShadowContainer>
    </div>
  </div>
  <div class="absolute bottom-0 left-0 h-1/2 max-h-[249px] w-1/2 max-w-[257px]">
    <img class="" src="/images/wrapped/flyingpiglaserbeam.png" alt="" />
  </div>
  <div
    class="absolute bottom-6 flex w-full flex-col items-center justify-center"
  >
    <WrappedTextContainer class="whitespace-nowrap text-[12px] text-white">
      dollardonationclub.com
    </WrappedTextContainer>
  </div>
</template>
